import { Injectable } from '@angular/core';

import { PicksRequest } from '@cds/query-objects';

import { BetslipGroupInformation } from '../../../core/groups/betslip-group-information';
import { BetslipPick } from '../../../core/picks/betslip-pick';
import { PickId } from '../../../core/picks/pick-id';
import { getPickRequestBuilder } from './builders/pick-request-data-provider.factory';

@Injectable()
export class BetslipPicksRequestBuilderService {
    buildRequestFromPickId(ids: PickId[], useLiveFallback: boolean = false, groupInfo?: BetslipGroupInformation): PicksRequest {
        const request: PicksRequest = {
            tv1Picks: [],
            tv2Picks: [],
        };

        const pickCheck: { [pickId: string]: boolean } = {};
        for (const pickId of ids) {
            if (pickCheck[pickId.toString()]) {
                continue;
            }
            getPickRequestBuilder(pickId).getPickDataRequest(pickId, request, useLiveFallback, groupInfo);
            pickCheck[pickId.toString()] = true;
        }

        return request;
    }

    buildRequestFromPicks(picks: BetslipPick[], useLiveFallback: boolean = false): PicksRequest {
        const request: PicksRequest = {
            tv1Picks: [],
            tv2Picks: [],
        };

        picks.forEach((p) => getPickRequestBuilder(p.id).getPickDataRequest(p.id, request, useLiveFallback, p.groupInfo));

        return request;
    }
}
